<template>
  <div class="bg-white shadow sm:rounded-lg">
    <div class="px-4 py-5 sm:p-6">

      <h3 class="text-base font-semibold leading-6 text-gray-900">{{ __('Allowlist') }}</h3>
      <div class="mt-2 max-w-xl text-sm text-gray-500 mb-4">
        <p>{{ __('Before the status page can be set up, the IP address must be set to the allowlist of the license. Otherwise the download is not available on the server.') }}</p>
      </div>

      <ul role="list" class="divide-y divide-gray-100">
        <li v-for="allowedEntry in license.license_allowlist" :key="allowedEntry.id" class="flex items-center justify-between gap-x-6 py-3">
          <div class="min-w-0">
            <div class="flex items-start gap-x-3">
              <p class="text-sm font-semibold leading-6 text-gray-900">{{ allowedEntry.ip_address }}</p>
            </div>
            <div class="mt-0.5 flex items-center gap-x-2 text-xs leading-5 text-gray-500">
              <p class="whitespace-nowrap">
                {{ __('Created at') }} <time :datetime="allowedEntry.created_at">{{ dateTime(allowedEntry.created_at) }}</time>
              </p>
            </div>
          </div>
          <div class="flex flex-none items-center gap-x-4">
            <inertia-link :method="'delete'" :href="route('license.allowlist.remove', {license, entry: allowedEntry})">
              <danger-button>{{ __('Remove') }}</danger-button>
            </inertia-link>
          </div>
        </li>

        <li class="flex justify-center items-center mx-auto" :class="{'pt-5': license.license_allowlist.length > 0}">
          <primary-button @click="addingIps = true">{{ __('Add new IP-Address') }}</primary-button>
        </li>
      </ul>
    </div>

      <!-- Add new ip's to allowlist -->
      <dialog-modal :show="addingIps" @close="closeForm">
        <template #title>
            {{ __('IP Approval') }}
        </template>

        <template #content>
            {{ __('Allow an IP address to your license by adding it to the Allowlist.') }}

            <div class="mt-4">
                <jet-input type="text" class="mt-1 block w-3/4" :placeholder="__('IP-Address')"
                           ref="ip_address"
                           v-model="form.ip_address"
                           @keyup.enter="addIpAddress" />

                <jet-input-error :message="form.errors.ip_address" class="mt-2" />
            </div>
        </template>

        <template #footer>
            <secondary-button @click="closeForm">
                {{ __('Cancel') }}
            </secondary-button>

            <jet-button class="ml-3" @click="addIpAddress" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                {{ __('Add') }}
            </jet-button>
        </template>
</dialog-modal>
    </div>
</template>

<script>
import { PaperClipIcon } from '@heroicons/vue/solid'
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import JetButton from "@/Jetstream/Button";
import SecondaryButton from "@/Jetstream/SecondaryButton";
import DialogModal from "@/Jetstream/DialogModal";
import DangerButton from "@/Jetstream/DangerButton";
import PrimaryButton from "@/Jetstream/PrimaryButton";
export default {
    name: "LicenseDetails",
    components: {
      PrimaryButton,
      DangerButton,
        JetInput,
        DialogModal,
        JetButton,
        SecondaryButton,
        JetInputError,
        PaperClipIcon,
    },
    props: ['license'],
    data() {
        return {
            addingIps: false,
            form: this.$inertia.form({
                ip_address: '',
            })
        };
    },
    methods: {
        addIpAddress() {
            this.form.put(route('license.allowlist.add', {license: this.license}), {
                preserveScroll: true,
                onSuccess: () => this.closeForm(),
                onError: () => this.$refs.ip_address.focus(),
                onFinish: () => this.form.reset(),
            });
        },
        closeForm() {
            this.addingIps = false;
            this.form.reset();
        }
    }
}
</script>
